import React from "react";

export default function NotFound(props) {
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <span className="text-5xl">Not found</span>
    </div>
  );
}
